<template>
    <div class="del modal_wrapper">
      <!-- 제목 및 헤더 : 시작 -->
      <div class="sub_Navi">
        <ul>
          <li>
            <a @click="goBack" class="back">뒤로</a>
          </li>
          <li>
            <h1>{{ $t("price['coinReg']") }}</h1>
          </li>
          <li class="linkBox"></li>
        </ul>
      </div>
      <!-- 제목 및 헤더 : 끝 -->
      <!-- 검색창 : 시작 -->
      <div class="subPage_container">
        <div class="coin_search_wrap">
          <div>
            <div class="select_wrap">
              <input type="text" id="exchange" class="select w48 modal_open" :value="selectedExchange"
                @click="showExchangeModal = true" readonly />
              <input type="text" id="market" name="" class="select w48 modal_open" :value="selectedMarket"
                @click="showMarketModal = true" readonly />
            </div>
            <div class="search_wrp">
              <input type="text" id="search" name="search" class="search_input"
                :placeholder="$t('alarm.score.searchCoin')" v-model="searchQuery" />
              <button class="search_clear" @click="searchQuery = ''"></button>
            </div>
          </div>
        </div>
        <!-- 검색창 : 끝 -->
        <!-- 코인 리스트 : 시작 -->
        <div class="coin_search_List insight">
          <ul>
            <li class="on" v-for="(coins, i) in filteredGoyaCoin" :key="i">
              <!--등록된 코인: 클래스 on 추가-->
              <div class="lt_1">
                <div class="coin_img">
                  <img :src="getImagePath(coins.coin)" @error="handleImageError(coins.coin, $event)" />
                </div>
                <h3 class="coin_name">
                  {{ coins.coin }}<span>/{{ coins.quote }}</span>
                </h3>
              </div>
              <div class="lt_2">{{ coins.exchange }}</div>
              <div class="lt_3">
                <input checked type="checkbox" :id="`coinChk_00${i}`" @change="toggleCoinSelection(coins)" /><label
                  :for="`coinChk_00${i}`"></label>
              </div>
            </li>
            <!-- 코인 리스트 -->
            <li v-for="(symbol, index) in filteredSymbols" :key="symbol.coin + '_' + index">
              <div class="lt_1">
                <div class="coin_img">
                  <img :src="getImagePath(symbol.coin)" @error="handleImageError(symbol.coin, $event)" />
                </div>
                <h3 class="coin_name">
                  {{ symbol.coin }}<span>/{{ symbol.quote }}</span>
                </h3>
              </div>
              <div class="lt_2">{{ symbol.exchange }}</div>
              <div class="lt_3">
                <input type="checkbox" :id="'coinChk_' + index" name="" @change="toggleCoinSelection(symbol)"
                  :checked="isSelected(symbol)" />
                <label :for="'coinChk_' + index"></label>
              </div>
            </li>
          </ul>
        </div>
        <!-- 코인 리스트 : 끝 -->
        
        <div class="subPage_container" v-if="!loadStatus">
          <div class="loading_spinner">
              <div class="loading_circle"></div>
          </div>
        </div>
  
        <!-- 데이터가 없을 경우 -->
        <div class="nodata2" v-if="loadStatus && !filteredSymbols.length">
          {{ $t("price['coinNotFound']") }}
        </div>
      </div>
  
      <!-- 하단 저장 버튼 -->
      <ModalBtn @click="saveCoins" />
  
      <!-- 거래소 모달창 : 시작 -->
      <div v-if="showExchangeModal">
        <div class="modalBackColor"></div>
        <div class="modal_wrap modal_no1">
          <div class="modal_title">
            {{ $t("alarm['rsi']['exchange']") }}
            <div class="mdcolsebtn" @click="showExchangeModal = false"></div>
          </div>
          <div class="modal_content">
            <div class="modal_exchange_list">
              <ul>
                <li v-for="(exchange, index) in availExc" :key="exchange" :class="{ active: selectedExchange == exchange}">
                  <div class="lt_1">
                    <div class="exc_img">
                      <img :src="getExchangeImage(exchange)" :alt="exchange" />
                      <!-- <img :src="'@/assets/images/exchange/ec_' + exchange.toLowerCase() + '.png'" :alt="exchange" /> -->
                      <!-- <img v-if="exchange === 'Binance'" src="@/assets/images/exchange/ec_binance.png" :alt="exchange" /> -->
                      <!-- <img v-else-if="exchange === 'Bybit'" src="@/assets/images/exchange/ec_bybit.png" :alt="exchange" /> -->
                      <!-- <img v-else-if="exchange === 'OKX'" src="/assets/images/exchange/ec_okx.png" :alt="exchange" /> -->
                    </div>
                    <h3 class="exc_name">{{ exchange }}</h3>
                  </div>
                  <div class="lt_2">
                    <input type="radio" :id="'exChk_' + index" name="exChk" @change="selectExchange(exchange)" />
                    <label :for="'exChk_' + index"></label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 거래소 모달창 : 끝 -->
  
      <!-- 마켓 모달창 : 시작 -->
      <div v-if="showMarketModal">
        <div class="modalBackColor"></div>
        <div class="modal_wrap modal_no2" data-modal="2">
          <div class="modal_title">
            {{ $t("alarm['rsi']['market']") }}
            <div class="mdcolsebtn" @click="showMarketModal = false"></div>
          </div>
          <div class="modal_content">
            <div class="modal_market_list">
              <ul>
                <li v-for="(market, index) in availableMarkets" :key="index" :class="{ active: selectedMarket == market }">
                  <div class="lt_1">
                    <h3 class="market_name">{{ market }}</h3>
                  </div>
                  <div class="lt_2">
                    <input type="radio" :id="'marketChk_' + index" name="marketChk" @change="selectMarket(market)" />
                    <label :for="'marketChk_' + index"></label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 마켓 모달창 : 끝 -->
      <div class="popupMessage">
        <span class="messageTxt"></span>
      </div>
    </div>
  </template>
  
  <script>
  import ModalBtn from "@/components/button/ModalBtn.vue";
 
  import { popupControll } from "@/utils/modalText";
  import { mapState, mapMutations, mapActions } from "vuex";
  
  export default {
    name: "CoinRsiModal",
    components: {
      ModalBtn, // 저장 버튼
    },
    data() {
      return {
        websocket: null,
        showErrorModal: false, // 에러 메세지 모달창 상태 변수
        errorMessage: "", // 에러 메세지 모달창 텍스트
  
        allSymbols: [], // 소켓에서 불러온 모든 코인
        searchQuery: "", // 검색어 추적
  
        selectedExchange: this.$t("price['selectEx']"), // 최초 실행시 거래소 선택
        showExchangeModal: false, // 거래소 선택 모달창 상태 변수
  
        selectedMarket: this.$t("price['selectMarket']"), // 최초 실행시 마켓 선택
        showMarketModal: false, // 마켓 선택 모달창 상태 변수
        availableMarkets: ["USDT", "KRW"], // 고정값
  
        selectedCoins: [], // 유저가 선택하는 코인 어레이 (추적)
        // availExc: ['Binance', 'Bybit', 'OKX'],
        availExc: ['Binance'],
  
        loadStatus: false,
        fallbackLoaded: false
      };
    },
  
    async mounted() {
      await this.getCoinList(); // 등록되어있는 코인 리스트
      await this.rsiCoinSelected(); // 이미 등록된 코인 필터링 후 등록되지 않은 코인 리스트에서 제외처리
      // this.AvailExcName(); // 이용가능한 거래소
    },
  
    beforeUnmount() {
      this.resetScroll();
    },
  
    computed: {
  ...mapState("coinReg", ["clickAdd"]),
  ...mapState("alarmRsi", [
    "goyaCoin",
    "binanceList",
    "bybitList",
    "okxList",
    "putCoin",
    ],
  ),
  subPath() {
    return this.$route.query?.sub
  },
  type() {
    return this.$route.query?.type;
  },

  // 이미 체크된 코인 필터링
  filteredGoyaCoin() {
    let symbols = [...this.goyaCoin];

    if (this.selectedExchange !== this.$t("price['selectEx']")) {
      symbols = symbols.filter(
        (symbol) => symbol.exchange === this.selectedExchange
      );
    }

    if (this.selectedMarket !== this.$t("price['selectMarket']")) {
      symbols = symbols.filter(
        (symbol) => symbol.quote === this.selectedMarket
      );
    }

    if (this.searchQuery.trim()) {
      const lowerCaseQuery = this.searchQuery.trim().toLowerCase();

      symbols = symbols.filter((symbol) =>
        symbol.coin.toLowerCase().includes(lowerCaseQuery)
      );
    }

    return symbols;
  },

  // 아직 체크되지 않은 코인 필터링
  filteredSymbols() {
    let symbols = this.flattenSymbols();

    if (this.selectedExchange !== this.$t("price['selectEx']")) {
      symbols = symbols.filter(
        (symbol) => symbol.exchange === this.selectedExchange
      );
    }

    if (this.selectedMarket !== this.$t("price['selectMarket']")) {
      symbols = symbols.filter(
        (symbol) => symbol.quote === this.selectedMarket
      );
    }

    if (this.searchQuery.trim()) {
      const lowerCaseQuery = this.searchQuery.trim().toLowerCase();

      symbols = symbols.filter((symbol) =>
        symbol.coin.toLowerCase().includes(lowerCaseQuery)
      );
    }

    return symbols;
  },
},
    methods: {
      // 팝업 모달
      popupControll,
  
      ...mapActions("alarmRsi", [
        "getCoinList",
        "getBinanceList",
        "getBybitList",
        "getOkxList",
        "putCoinList",
      ]),
  
      // 모달창
      ...mapMutations("alarmRsi", ["saveRsiCoins"]),
  
      resetScroll() {
        const allElements = document.querySelectorAll("*");
  
        allElements.forEach((el) => {
          if (
            el.scrollHeight > el.clientHeight ||
            el.scrollWidth > el.clientWidth
          ) {
            el.scrollTo(0, 0);
          }
        });
  
        window.scrollTo(0, 0);
      },
  
      // 거래소 코인 리스트 가져오기
      async getAllCoins() {
        try {
          await this.getBinanceList();
          // await this.getBybitList();
          // await this.getOkxList();
  
          for (let binanCoin of this.binanceList) {
            this.allSymbols.push({
              exchange: "Binance",
              quote: "USDT",
              coin: binanCoin,
            });
          }
  
          // for (let bybitCoin of this.bybitList) {
          //   this.allSymbols.push({
          //     exchange: "Bybit",
          //     quote: "USDT",
          //     coin: bybitCoin,
          //   });
          // }
  
          // for (let okxCoin of this.okxList) {
          //   this.allSymbols.push({
          //     exchange: "OKX",
          //     quote: "USDT",
          //     coin: okxCoin,
          //   });
          // }
        } catch (error) {
          console.error("Error getAllCoins:", error);
        }
      },
  
      // 코인별 이미지 호출
      getImagePath(coin) {
        // const symbol = coin + "USDT";
        const baseSymbol = coin.toLowerCase();
        try {
          return require("@/assets/images/coin_logos/" + baseSymbol + ".svg");
        } catch {
          return require("@/assets/images/coin_logos/default.svg");
        }
      },
  
      handleImageError(symbol, event) {
        const baseSymbol = symbol.replace("USDT", "").toLowerCase();
        event.target.src = require("@/assets/images/coin_logos/" +
          baseSymbol +
          ".png");
      },
  
      // 필터링 함수
      flattenSymbols() {
        return [].concat(...Object.values(this.allSymbols));
      },
      selectExchange(exchange) {
        this.selectedExchange =
          exchange !== this.$t("price['selectEx']") ? exchange : "";
        this.showExchangeModal = false;
      },
      selectMarket(market) {
        this.selectedMarket =
          market !== this.$t("price['selectMarket']") ? market : "";
        this.showMarketModal = false;
      },
  
      // 이미 등록된 코인 선택된 코인 리스트에 넣어주는 기능
      allSelectedCoins() {
        for (let goya of this.goyaCoin) {
          this.selectedCoins.push({
            exchange: goya.exchange,
            quote: goya.quote,
            coin: goya.coin,
          });
        }
      },
  
      // 유저가 코인 선택시 selectedCoins 어레이에 추가, 선택헤제 시 어레이에서 삭제
      toggleCoinSelection(symbol) {
        const coinIndex = this.selectedCoins.findIndex(
          (coin) => coin.coin === symbol.coin && coin.exchange === symbol.exchange
        );
        if (coinIndex === -1) {
          this.selectedCoins.push({
            exchange: symbol.exchange,
            quote: symbol.quote,
            coin: symbol.coin,
          });
        } else {
          this.selectedCoins.splice(coinIndex, 1);
        }
  
        this.saveRsiCoins(this.selectedCoins);
      },
      
      // 거래소 이미지 가져오는 함수
      getExchangeImage(exchange) {

        if (!this.fallbackLoaded) {
          try {
            return require(`@/assets/images/exchange/ec_${exchange.toLowerCase()}.png`);
          } catch (e) {
            this.fallbackLoaded = true;
            return `/assets/images/exchange/ec_${exchange.toLowerCase()}.png`;
          }
        } 
        else {
          return `/assets/images/exchange/ec_${this.exchange.toLowerCase()}.png`;
        }
      },
  
      // 이미 등록된 코인 필터링 후 등록되지 않은 코인 리스트에서 제외처리
      async rsiCoinSelected() {
        this.loadStatus = false;
        await this.getAllCoins();
  
        const goyaData = this.goyaCoin;
  
        this.allSymbols = this.allSymbols.filter((symbol) => {
          const goyaExc = symbol.exchange;
          const goyaQu = symbol.quote;
          const goyaCoin = symbol.coin;
  
          const isSelected = goyaData.some(
            (data) =>
              data.exchange === goyaExc &&
              data.quote === goyaQu &&
              data.coin === goyaCoin
          );
          return !isSelected;
        });
        this.nonSelected = this.allSymbols;
        this.allSelectedCoins();
        this.loadStatus = true;
      },
  
      isSelected(symbol) {
        return this.selectedCoins.some(
          (selectedCoin) =>
            selectedCoin.coin === symbol.coin &&
            selectedCoin.exchange === symbol.exchange
        );
      },
  
      // 저장 버튼 눌렀을 때 작동되는 함수
      saveCoins() {
        if (this.selectedCoins.length >= 21) {
          this.popupControll(this.$t("popup.goyaAlarmLimit"));
          return;
        } else {
          if (this.putCoin.length == 0 && this.selectedCoins.length != 0) {
            this.saveRsiCoins(this.goyaCoin);
            this.putCoinList();
          } else {
            this.putCoinList();
          }
        }
  
        this.$router.push(`/alarm/${this.subPath}?type=${this.type}`)
      },
      goBack() {
        this.$router.push(`/alarm/${this.subPath}?type=${this.type}`)
      }
    },
  };
  </script>
  
  <style scoped>
  .subPage_container {
    height: auto;
  }
  
  .modal_wrap {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50%;
    background: var(--Menu-Dark, #222223);
    border-radius: 15px 15px 0 0;
    overflow-y: auto;
    display: block;
    justify-content: center;
    align-items: center;
  }
  
  /*모달창*/
  .modalBackColor {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
  
  /* 저장버튼 */
  .btn_bottom_wrap {
    padding-top: 15px;
  }
  </style>
  